import { WarningAltFilled } from '@carbon/react/icons';

// The "address confidence issue" marker used in both reconcile tables' dedicated
// flag column. Carbon's WarningAltFilled, recolored by a `className` (precedent:
// well-survey-structure-grid-empty-state uses WarningFilled the same way), so the
// callers keep control of the fill/size via their scss and the markup stays a
// single shared source instead of a hand-rolled SVG.
export const WarningCircleIcon = ({ className }: { className?: string }) => (
  <WarningAltFilled size={20} className={className} aria-hidden />
);
